import React from 'react';
import { BrowserRouter, Routes, Route, Navigate, useParams } from 'react-router-dom';
import { isPublicBrandSlug } from './tenant';
import Login from './pages/Login';
import SuperAdminLogin from './pages/SuperAdminLogin';
import SuperAdminDashboard from './pages/SuperAdminDashboard';
import RoleBasedDashboard from './pages/RoleBasedDashboard';
import ManagerDashboard from './pages/ManagerDashboard';
import Customers from './pages/Customers';
import Policies from './pages/Policies';
import Claims from './pages/Claims';
import NewPolicy from './pages/NewPolicy';
import ImportData from './pages/ImportData';
import CompanyUsers from './pages/CompanyUsers';
import CompanySettings from './pages/CompanySettings';
import CompanyApiKeys from './pages/CompanyApiKeys';
import ClientPolicyLookup from './pages/ClientPolicyLookup';
import ClientLogin from './pages/ClientLogin';
import ClientPortal from './pages/ClientPortal';
import PoliceVerify from './pages/PoliceVerify';
import MotorCertificatePrint from './pages/MotorCertificatePrint';
import ReceiptPrint from './pages/ReceiptPrint';
import Renewals from './pages/Renewals';
import FinanceReport from './pages/FinanceReport';
import UssdDemo from './pages/UssdDemo';
import 'bootstrap/dist/css/bootstrap.min.css';

function PublicBrandGate({ children, fallback }) {
    const { slug } = useParams();
    if (!isPublicBrandSlug(slug)) {
        return <Navigate to={fallback} replace />;
    }
    return children;
}

function App() {
    return (
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<Navigate to="/login" />} />
                <Route path="/login" element={<Login />} />
                <Route path="/c/:slug" element={<PublicBrandGate fallback="/login"><Login /></PublicBrandGate>} />
                <Route path="/c/:slug/client" element={<PublicBrandGate fallback="/client/login"><ClientLogin /></PublicBrandGate>} />
                <Route path="/my-policy" element={<ClientPolicyLookup />} />
                <Route path="/verify" element={<PoliceVerify />} />
                <Route path="/verify/:token" element={<PoliceVerify />} />
                <Route path="/ussd" element={<UssdDemo />} />
                <Route path="/card" element={<ClientPolicyLookup />} />
                <Route path="/client/login" element={<ClientLogin />} />
                <Route path="/client" element={<ClientPortal />} />
                <Route path="/print/motor-certificate" element={<MotorCertificatePrint />} />
                <Route path="/print/receipt" element={<ReceiptPrint />} />
                <Route path="/super-admin/login" element={<SuperAdminLogin />} />
                <Route path="/super-admin" element={<SuperAdminDashboard />} />
                <Route path="/pulse-admin" element={<Navigate to="/super-admin/login" />} />
                <Route path="/pulse-admin/login" element={<Navigate to="/super-admin/login" />} />
                <Route path="/dashboard" element={<RoleBasedDashboard />} />
                <Route path="/manager" element={<ManagerDashboard />} />
                <Route path="/customers" element={<Customers />} />
                <Route path="/policies" element={<Policies />} />
                <Route path="/renewals" element={<Renewals />} />
                <Route path="/returns" element={<FinanceReport />} />
                <Route path="/claims" element={<Claims />} />
                <Route path="/new-policy" element={<NewPolicy />} />
                <Route path="/import" element={<ImportData />} />
                <Route path="/team" element={<CompanyUsers />} />
                <Route path="/api-keys" element={<CompanyApiKeys />} />
                <Route path="/settings" element={<CompanySettings />} />
                <Route path="*" element={<Navigate to="/login" />} />
            </Routes>
        </BrowserRouter>
    );
}

export default App;
